var map = {
	"./epub_logo_color": 65,
	"./epub_logo_color.svg": 65,
	"./header-stripes": 66,
	"./header-stripes.png": 66,
	"./insights/carbon-footprint-review-copies-fig-1": 67,
	"./insights/carbon-footprint-review-copies-fig-1.jpg": 67,
	"./landing_hero_large": 68,
	"./landing_hero_large.jpg": 68,
	"./landing_side_bookshops": 69,
	"./landing_side_bookshops.jpg": 69,
	"./landing_side_publishers": 70,
	"./landing_side_publishers.jpg": 70,
	"./landing_side_readers": 71,
	"./landing_side_readers.jpg": 71,
	"./logos/ace": 72,
	"./logos/ace.png": 72,
	"./logos/ba": 73,
	"./logos/ba.png": 73,
	"./logos/blackwells": 74,
	"./logos/blackwells.png": 74,
	"./logos/facebook": 75,
	"./logos/facebook.svg": 75,
	"./logos/innovate_uk": 76,
	"./logos/innovate_uk.png": 76,
	"./logos/publishers-association": 77,
	"./logos/publishers-association.png": 77,
	"./logos/twitter": 78,
	"./logos/twitter.svg": 78,
	"./nav-bar-icons": 79,
	"./nav-bar-icons.svg": 79,
	"./opengraph_share_default_de": 80,
	"./opengraph_share_default_de.jpg": 80,
	"./opengraph_share_default_en": 81,
	"./opengraph_share_default_en.jpg": 81,
	"./products/discovery-retailers-details": 82,
	"./products/discovery-retailers-details.jpg": 82,
	"./products/discovery-retailers-landing": 83,
	"./products/discovery-retailers-landing-zoomed": 84,
	"./products/discovery-retailers-landing-zoomed.jpg": 84,
	"./products/discovery-retailers-landing.jpg": 83,
	"./products/retailers-customised-1-hero": 85,
	"./products/retailers-customised-1-hero.jpg": 85,
	"./products/retailers-customised-2-sample01": 86,
	"./products/retailers-customised-2-sample01.jpg": 86,
	"./products/retailers-customised-3-bookshop-info": 87,
	"./products/retailers-customised-3-bookshop-info.jpg": 87,
	"./products/retailers-customised-4-reserve": 88,
	"./products/retailers-customised-4-reserve.jpg": 88,
	"./products/retailers-customised-5-sample02": 89,
	"./products/retailers-customised-5-sample02.jpg": 89,
	"./products/retailers-customised-6-sample03": 90,
	"./products/retailers-customised-6-sample03.jpg": 90,
	"./products/retailers-customised-7-sample04": 91,
	"./products/retailers-customised-7-sample04.jpg": 91,
	"./products/retailers-customised-8-sample05": 92,
	"./products/retailers-customised-8-sample05.jpg": 92,
	"./products/retailers-customised-9-sample06": 93,
	"./products/retailers-customised-9-sample06.jpg": 93,
	"./products/retailers-ecommerce-1-hero": 94,
	"./products/retailers-ecommerce-1-hero.jpg": 94,
	"./products/retailers-ecommerce-2-sample01": 95,
	"./products/retailers-ecommerce-2-sample01.jpg": 95,
	"./products/retailers-ecommerce-3-sample02": 96,
	"./products/retailers-ecommerce-3-sample02.jpg": 96,
	"./products/retailers-ecommerce-4-sample03": 97,
	"./products/retailers-ecommerce-4-sample03.jpg": 97,
	"./products/retailers-ecommerce-5-sample04": 98,
	"./products/retailers-ecommerce-5-sample04.jpg": 98,
	"./products/retailers-ecommerce-6-portal": 99,
	"./products/retailers-ecommerce-6-portal.jpg": 99,
	"./products/retailers-ecommerce-7-waterstones-sample": 100,
	"./products/retailers-ecommerce-7-waterstones-sample.jpg": 100,
	"./products/retailers-newsletter-1-hero": 101,
	"./products/retailers-newsletter-1-hero.jpg": 101,
	"./products/retailers-newsletter-2-blackwells": 102,
	"./products/retailers-newsletter-2-blackwells.jpg": 102,
	"./products/retailers-newsletter-3-guardian": 103,
	"./products/retailers-newsletter-3-guardian.jpg": 103,
	"./products/retailers-og-1": 104,
	"./products/retailers-og-1.jpg": 104,
	"./products/retailers-og-2": 105,
	"./products/retailers-og-2.jpg": 105,
	"./products/retailers-og-3": 106,
	"./products/retailers-og-3.jpg": 106,
	"./products/retailers-og-4": 107,
	"./products/retailers-og-4.jpg": 107,
	"./products/retailers-og-5": 108,
	"./products/retailers-og-5.jpg": 108,
	"./products/retailers-og-6": 109,
	"./products/retailers-og-6.jpg": 109,
	"./products/retailers-product-2-grumpus": 110,
	"./products/retailers-product-2-grumpus.jpg": 110,
	"./products/retailers-product-3-newsletters": 111,
	"./products/retailers-product-3-newsletters.jpg": 111,
	"./products/retailers-product-4-tweets": 112,
	"./products/retailers-product-4-tweets.jpg": 112,
	"./products/retailers-product-5-product-page": 113,
	"./products/retailers-product-5-product-page.jpg": 113,
	"./products/retailers-socialmedia-1-hero": 114,
	"./products/retailers-socialmedia-1-hero.jpg": 114,
	"./products/retailers-socialmedia-2-tweets-blackwells": 115,
	"./products/retailers-socialmedia-2-tweets-blackwells.jpg": 115,
	"./products/retailers-socialmedia-3-tweets-multi-links": 116,
	"./products/retailers-socialmedia-3-tweets-multi-links.jpg": 116,
	"./products/retailers-socialmedia-4-buy-pages": 117,
	"./products/retailers-socialmedia-4-buy-pages.jpg": 117,
	"./products/retailers-socialmedia-5-smart-link": 118,
	"./products/retailers-socialmedia-5-smart-link.jpg": 118,
	"./products/retailers-socialmedia-6-excerpt-page": 119,
	"./products/retailers-socialmedia-6-excerpt-page.jpg": 119,
	"./qr/audiobook-qr-colour": 120,
	"./qr/audiobook-qr-colour.svg": 120,
	"./qr/audiobook-qr-mono": 121,
	"./qr/audiobook-qr-mono.svg": 121,
	"./qr/graphic-qr-colour": 122,
	"./qr/graphic-qr-colour.svg": 122,
	"./qr/graphic-qr-mono": 123,
	"./qr/graphic-qr-mono.svg": 123,
	"./qr/illustrated-qr-colour": 124,
	"./qr/illustrated-qr-colour.svg": 124,
	"./qr/illustrated-qr-mono": 125,
	"./qr/illustrated-qr-mono.svg": 125,
	"./qr/narrative-qr-colour": 51,
	"./qr/narrative-qr-colour.svg": 51,
	"./qr/narrative-qr-mono": 52,
	"./qr/narrative-qr-mono.svg": 52,
	"./readers-landing-page": 126,
	"./readers-landing-page.jpg": 126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;